"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
var React = __importStar(require("react"));
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var classnames_1 = __importDefault(require("classnames"));
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        marginBottom: t.spacing(2),
        border: "1px solid " + t.palette.divider
    },
    loader: {
        marginBottom: -5,
    },
    hover: {
        cursor: 'pointer',
        transition: t.transitions.create('all'),
        '&:hover': {
            transform: 'scale(1.01)',
            boxShadow: t.shadows[4],
        }
    }
}); });
var Panel = function (_a) {
    var className = _a.className, hoverable = _a.hoverable, loading = _a.loading, children = _a.children, other = __rest(_a, ["className", "hoverable", "loading", "children"]);
    var classes = useStyles();
    return (React.createElement("div", __assign({ className: (0, classnames_1.default)(classes.root, hoverable && classes.hover, className) }, other),
        loading && React.createElement(material_1.LinearProgress, { className: classes.loader }),
        children));
};
exports.Panel = Panel;
//# sourceMappingURL=Panel.js.map